import { z } from 'zod';

export const LegacyFetchErrorMessageSchema = z.object({
    message: z.string(),
    phraseId: z.number(),
    phrasePlaceholders: z.array(z.string()).optional(),
    secondsLeft: z.number().optional(),
});

export type LegacyFetchErrorMessage = z.infer<typeof LegacyFetchErrorMessageSchema>;

export const LegacyFetchErrorFormatSchema = z.object({
    statusCode: z.number(),
    timestamp: z.string(),
    path: z.string(),
    message: z.union([LegacyFetchErrorMessageSchema, z.string()]),
});

export type LegacyFetchErrorFormat = z.infer<typeof LegacyFetchErrorFormatSchema>;

export const NewFetchErrorFormatSchema = z.object({
    errors: z.array(
        z.object({
            property: z.string().optional(),
            path: z.array(z.string()).optional(),
            message: z.string().optional(),
            isMessageUserFriendly: z.boolean().optional(),
            phraseId: z.number().optional(),
            phrasePlaceholders: z.array(z.union([z.string(), z.number()])).optional(),
            helpUrl: z.string().optional(),
            data: z.record(z.string(), z.unknown()).optional(),
            type: z.enum(['error', 'info', 'success', 'warning']).optional(),
        }),
    ),
});

export type NewFetchErrorFormat = z.infer<typeof NewFetchErrorFormatSchema>;

export const FetchErrorMessageSchema = z.union([
    z.string(),
    z.array(z.unknown()),
    z.looseObject({ message: z.unknown() }),
    z.object({ errors: z.array(z.unknown()) }),
]);

export type FetchErrorMessage = z.infer<typeof FetchErrorMessageSchema>;

export const ErrorDataSchema = z.object({
    phraseId: z.number().optional(),
    message: z.string().optional(),
    isMessageUserFriendly: z.boolean().optional(),
    phrasePlaceholders: z.array(z.union([z.string(), z.number()])).optional(),
    helpUrl: z.string().optional(),
    data: z.record(z.string(), z.unknown()).optional(),
    type: z.enum(['error', 'info', 'success', 'warning']).optional(),
});

export type ErrorData = z.infer<typeof ErrorDataSchema>;

export const FetchErrorsTypeSchema = z.union([
    z.undefined(),
    z.object({
        generalErrors: z.array(ErrorDataSchema),
        propertyErrors: z.record(z.string(), z.array(ErrorDataSchema)),
    }),
]);

export type FetchErrorsType = z.infer<typeof FetchErrorsTypeSchema>;
